import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import { Circle, Icon, Text } from "ol/style";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { MyMap } from "../View/MyMap";

import userimg from "../../../Assets/user.png";
import arrow from "../../../Assets/arrow.png"

const styled = (type, name) => {
  return [
    type !== "Polygon"
      ? new Style({
          image: new Icon({
            anchor: [0.5, 650],
            anchorXUnits: "fraction",
            anchorYUnits: "pixels",
            scale: 0.1,
            src: userimg,
          }),
          text: new Text({
            font: "12px Calibri,sans-serif",
            fill: new Fill({ color: "#000" }),
            stroke: new Stroke({
              color: "#fff",
              width: 4,
            }),
            text: name,
          }),
        })
      : new Style({
          stroke: new Stroke({
            color: "#B22222",
            width: 5,
          }),
          fill: new Fill({
            color: "red",
          }),
          text: new Text({
            font: "12px Calibri,sans-serif",
            fill: new Fill({ color: "#000" }),
            stroke: new Stroke({
              color: "#fff",
              width: 2,
            }),
            text: name,
          }),
        }),
  ];
};

const styledNew = (type, geometry, label) => {
    if (type == 'LineString') {
        const styles = [
            // linestring
            new Style({
                stroke: new Stroke({
                    color: '#0000FF', // Alternatifler: '#FFA500'; // Hex kodu: Turuncu, '#800080'; // Hex kodu: Mor, '#FFD700'; // Hex kodu: Altın sarısı
                    width: 5
                }),
            }),
        ];
        geometry.forEachSegment(function (start, end) {
            //console.log('sdf' , start , end )
            const dx = end[0] - start[0];
            const dy = end[1] - start[1];
            const rotation = Math.atan2(dy, dx);
            // arrows
            styles.push(
                new Style({
                    geometry: new Point(end),
                    image: new Icon({
                        src: arrow,
                        anchor: [0.75, 0.5],
                        rotateWithView: true,
                        rotation: -rotation,
                        scale: .05
                    }),
                    stroke: new Stroke({
                        color: '#0000FF', // Alternatifler: '#FFA500'; // Hex kodu: Turuncu, '#800080'; // Hex kodu: Mor, '#FFD700'; // Hex kodu: Altın sarısı
                        width: 5
                    }),
                })
            );
        });
        // console.log(styles)
        return styles;
    }
    return [
        type == 'Point' ?
            new Style({
                image: new Circle({
                    radius: 6,
                    fill: new Fill({ color: 'orangered' }),
                    stroke: new Stroke({
                        color: [0, 0, 0], width: 2
                    })
                }),
                text: new Text({
                    font: '12px Calibri,sans-serif',
                    fill: new Fill({ color: '#000' }),
                    stroke: new Stroke({
                        color: '#A6FF96', width: 10
                    }),
                    // get the text from the feature - this is ol.Feature
                    // and show only under certain resolution
                    text: MyMap.getView().getZoom() > 12 ? label : ''
                }),
            })
            : new Style({
                stroke: new Stroke({
                    color: '#0000FF', // Alternatifler: '#FFA500'; // Hex kodu: Turuncu, '#800080'; // Hex kodu: Mor, '#FFD700'; // Hex kodu: Altın sarısı
                    width: 5
                }),
                fill: new Fill({
                    color: 'rgb(0, 0, 255, 0.3)', // Alternatifler: '#FFA500'; // Hex kodu: Turuncu, '#800080'; // Hex kodu: Mor, '#FFD700'; // Hex kodu: Altın sarısı
                })
            })
    ]
}

export const userLayer = new VectorLayer({
  opacity: 1,
  name: "userLayer",
  visible: true,
  zIndex: 30,
  source: new VectorSource({}),
});

export const locationLayer = new VectorLayer({
  opacity: 1,
  name: "Kullanıcı Konum Geçmişi",
  visible: true,
  zIndex: 10000,
  source: new VectorSource({}),
});

export const addLineToLocationLayer = (data) => {
  locationLayer.getSource().clear();
  // FEATURE ekliyoruz.
  if (data == null || data == undefined) {
    return;
  }
  let feature = new Feature({
    geometry: new GeoJSON().readFeature(data).getGeometry(),
  });
  feature.setStyle(styledNew(feature.getGeometry().getType(), feature.getGeometry()));
  locationLayer.getSource().addFeature(feature);
};

export const clearLocationLayer = () => {
  locationLayer.getSource().clear();
}

export const addSingleFeatureTouserLayerByXY = (x, y, name) => {
  if (x == null || y == null) {
    console.log("Gösterilecek X/Y Bulunamadı.");
    return;
  }
  let feature = new Feature(
    { geometry: new Point([x, y]) } // eslint-disable-next-line
  );
  // console.log(feature.getGeometry().getType())
  feature.setStyle(styled(feature.getGeometry().getType(), name));
  userLayer.getSource().addFeature(feature);
};

export const zoomToFeatureByXY = (x, y, zoomLevel) => {
  let feature = new Feature(
    { geometry: new Point([x, y]) } // eslint-disable-next-line
  );
  MyMap.getView().fit(feature.getGeometry().getExtent(), { maxZoom: zoomLevel == undefined ? 21 : zoomLevel, duration: 2000 });
};
